import { throwUa } from "./errors";
import { supabase } from "./supabase";
import { TelegramAdminSetting, TelegramLink } from "../models/telegram";

const BOT_URL = "https://t.me/NeoteploPartnerBot";

export const fetchTelegramLink = async (): Promise<TelegramLink | null> => {
  const { data, error } = await supabase
    .from("telegram_links")
    .select("*")
    .maybeSingle<TelegramLink>();
  if (error) throwUa(error);
  return data;
};

export const fetchTelegramAdminSetting = async (
  profileId: string
): Promise<TelegramAdminSetting | null> => {
  const { data, error } = await supabase
    .from("telegram_admin_settings")
    .select("*")
    .eq("profile_id", profileId)
    .maybeSingle<TelegramAdminSetting>();
  if (error) throwUa(error);
  return data;
};

export const disconnectTelegram = async (
  isStaff: boolean,
  id: string
): Promise<void> => {
  if (isStaff) {
    const { error } = await supabase
      .from("telegram_admin_settings")
      .delete()
      .eq("id", id);
    if (error) throwUa(error);
    return;
  }
  const { error } = await supabase
    .from("telegram_links")
    .delete()
    .eq("user_id", id);
  if (error) throwUa(error);
};

export const createConnectUrl = async (): Promise<string> => {
  const { data, error } = await supabase
    .from("telegram_connect_tokens")
    .insert({ user_id: (await supabase.auth.getUser()).data.user!.id })
    .select("token")
    .single<{ token: string }>();
  if (error || !data) throwUa(error);
  return `${BOT_URL}?start=${(data as { token: string }).token}`;
};

export const sendPartnerSignupNotification = async (payload: {
  partner: {
    id: string;
    name: string;
    email: string;
    company: string | null;
    phone: string | null;
  };
}): Promise<void> => {
  const { error } = await supabase.functions.invoke("notify", {
    body: { event: "partner_signup", ...payload },
  });
  if (error) throwUa(error);
};

export const sendProjectNotification = async (payload: {
  event: "new_project" | "status_change" | "bonus_change" | "comment_change";
  project_id: string;
  project_name: string;
  project_code: string | null;
  owner_id: string;
  status?: string;
  bonus_amount?: number | null;
  manager_comment?: string | null;
}): Promise<void> => {
  const { data: link, error: linkError } = await supabase
    .from("telegram_links")
    .select("linked")
    .eq("user_id", payload.owner_id)
    .maybeSingle<{ linked: boolean }>();
  if (linkError) throwUa(linkError);
  if (!link?.linked) return;
  const { error } = await supabase.functions.invoke("notify", {
    body: payload,
  });
  if (error) throwUa(error);
};
